module.exports = __webpack_public_path__ + "media/summer_2024_sweepstakes/tiktok-3339de12.svg";